import { render, staticRenderFns } from "./PerrmissionManagement.vue?vue&type=template&id=10858f68&scoped=true&"
import script from "./PerrmissionManagement.vue?vue&type=script&lang=ts&"
export * from "./PerrmissionManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PerrmissionManagement.vue?vue&type=style&index=0&id=10858f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10858f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCheckbox,VSimpleTable})
